/* @flow */
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import Translate from 'react-translate-component';
import { SpinnerButton } from 'components';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import { UserService } from 'frilans-finans';

import Utils from 'frilans-finans/utils/utils';
import { fetchBanks } from 'redux/modules/bank-info';
import BankInfoForm from '../../settings/salary-info/bank-info-form';
import ContactInformation from './contact-information';
import ModalContainer from '../../../frilans-finans/modal/modal-container';
import InvoicingInformation from './invoicing-information';

export class InvoiceToolCompleteInformationModal extends React.Component {

  static propTypes = {
    invoiceToolCompleteInformationModalIsOpen: PropTypes.bool.isRequired,
    toggleModal: PropTypes.func.isRequired,
    createInvoice: PropTypes.func.isRequired,
    isValid: PropTypes.bool.isRequired,
    bankInfo: PropTypes.object.isRequired,
    classes: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired,
    preReport: PropTypes.bool.isRequired,
    saveInvoice: PropTypes.func.isRequired,
    fetchBanks: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      userData: this.userDataTemplate(),
      showErrorWithoutBlur: false,
      loading: false,
      postError: false,
      currentPage: 1
    };

    this.callback = this.callback.bind(this);
    this.clickPrevious = this.clickPrevious.bind(this);
    this.clickNext = this.clickNext.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.setCountry = this.setCountry.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleError = this.handleError.bind(this);
    this.createInvoice = this.createInvoice.bind(this);
    this.resetState = this.resetState.bind(this);
    this.renderBody = this.renderBody.bind(this);
    this.hasValidBankInfo = this.hasValidBankInfo.bind(this);
    this.hasProfessionId = this.hasProfessionId.bind(this);
    this.setPage = this.setPage.bind(this);
    this.pageIsValid = this.pageIsValid.bind(this);
  }

  userDataTemplate () {
    return {
      cellphone: this.props.user.cellphone
        ? { value: this.props.user.cellphone, valid: true }
        : { value: '', valid: false },
      city: this.props.user.address.city
        ? { value: this.props.user.address.city, valid: true }
        : { value: '', valid: false },
      street: this.props.user.address.street
        ? { value: this.props.user.address.street, valid: true }
        : { value: '', valid: false },
      zip: this.props.user.address.zip
        ? { value: this.props.user.address.zip, valid: true }
        : { value: '', valid: false },
      profession: this.props.user.professionId
        ? { value: this.props.user.professionTitle, valid: true, id: this.props.user.professionId }
        : { value: '', valid: false, id: null },
      saveVacationPay: this.props.user.saveVacationPay
        ? { value: this.props.user.saveVacationPay, valid: true }
        : { value: null, valid: false }
    };
  }

  componentDidMount () {
    this.props.fetchBanks();
  }

  setCountry (country) {
    this.callback('country', { value: country, valid: true });
  }
  resetState () {
    this.setState({
      userData: this.userDataTemplate(),
      showErrorWithoutBlur: false,
      loading: false
    });
  }

  createInvoice () {
    if (this.props.preReport) {
      this.props.saveInvoice();
    } else {
      this.props.createInvoice();
    }
  }

  callback (name, values) {
    var tempFormValues = this.state.userData;
    tempFormValues[name] = values;
    this.setState({ userData: tempFormValues });
  }

  clickPrevious () {
    if (this.state.currentPage === 1) {
      this.resetState();
      this.props.toggleModal(false);
    } else {
      this.setState({
        currentPage: this.state.currentPage - 1
      });
    }
  }

  setPage (event) {
    let currentPage = this.state.currentPage;
    let targetPage = parseInt(event.target.id);

    if (event && event.target) {
      if (this.state.currentPage === 1 && this.hasValidUserInfo()) {
        if (targetPage === 2 || (this.hasValidUserInfo() && targetPage === 3)) {
          currentPage = targetPage;
        }
      }

      if (this.state.currentPage === 2) {
        if (targetPage === 1 || (this.hasValidBankInfo() && targetPage === 3)) {
          currentPage = targetPage;
        }
      }

      if (this.state.currentPage === 3) {
        currentPage = targetPage;
      }
    }

    this.setState({
      showErrorWithoutBlur: false,
      currentPage: currentPage
    });
  }

  pageIsValid () {
    switch (this.state.currentPage) {
      case 1:
        return this.hasValidUserInfo();
      case 2:
        return this.hasValidBankInfo();
      case 3:
        return Utils.validateInputValues(this.state.userData) &&
        this.hasValidBankInfo() &&
        this.hasProfessionId();
      default:
        return false;
    }
  }

  clickNext (e) {
    e.preventDefault();
    this.setState({ showErrorWithoutBlur: true }, () => {
      if (this.state.currentPage === 1 && this.pageIsValid()) {
        this.setState({
          showErrorWithoutBlur: false,
          currentPage: this.state.currentPage + 1
        });
      }

      if (this.state.currentPage === 2 && this.pageIsValid()) {
        this.setState({
          showErrorWithoutBlur: false,
          currentPage: this.state.currentPage + 1
        });
      }

      if (this.state.currentPage === 3 && this.pageIsValid()) {
        this.setState({
          showErrorWithoutBlur: false
        });
        this.submitForm();
      }
    });
  }

  hasProfessionId () {
    if (
      (!this.props.user.professionId && Number.isInteger(+this.state.userData.profession.id)) ||
      this.props.user.professionId
    ) {
      return true;
    }
    return false;
  }

  hasValidBankInfo () {
    return this.props.bankInfo.accountNumber.isValid &&
      this.props.bankInfo.clearingNumber.isValid;
  }

  hasValidUserInfo () {
    return this.state.userData.cellphone.valid &&
      this.state.userData.city.valid &&
      this.state.userData.street.valid &&
      this.state.userData.zip.valid;
  }

  submitForm () {
    const userData = Utils.getPostParams(this.state.userData);
    const isInternationalAccount = this.props.bankInfo.selectedBank === 'IBAN';

    const userUpdateData = {
      city: userData.city,
      country: userData.country,
      street: userData.street,
      zip: userData.zip,
      professionId: this.state.userData.profession ? this.state.userData.profession.id : null,
      accountNr: !isInternationalAccount ? this.props.bankInfo.accountNumber.value : null,
      accountClearingNr: !isInternationalAccount ? this.props.bankInfo.clearingNumber.value : null,
      bic: isInternationalAccount ? this.props.bankInfo.clearingNumber.value : null,
      iban: isInternationalAccount ? this.props.bankInfo.accountNumber.value : null,
      saveVacationPay: userData.saveVacationPay,
      cellphone: userData.cellphone
    };

    userUpdateData.internationalAccount = isInternationalAccount ? 'on' : 'off';

    this.setState({
      loading: true,
      postError: false
    });

    UserService.update(userUpdateData)
      .then(this.handleSuccess)
      .catch(this.handleError);
  }

  handleSuccess () {
    this.setState({
      loading: false
    });

    this.createInvoice();
  }

  handleError (error) {
    let errors = UserService.getError(error);

    this.setState({
      loading: false,
      error: true,
      errorMessage: errors
    });
  }

  getHeaderSlot () {
    const defaultStyle = 'complete-information-modal-progress-item';
    let firstItem = 'active';
    let secondItem = '';
    let thirdItem = '';

    if (this.state.currentPage === 2) {
      firstItem = 'visited';
      secondItem = 'active';
      thirdItem = '';
    }

    if (this.state.currentPage === 3) {
      firstItem = 'visited';
      secondItem = 'visited';
      thirdItem = 'active';
    }

    return (
      <div className='complete-information-modal-progress'>
        <Translate
          className={`${defaultStyle} ${firstItem}`}
          onClick={this.setPage}
          id={1}
          content='COMPLETE_INFORMATION_ORDER_TOOL_CONTACT_INFO_TAB'
        />
        <Translate
          className={`${defaultStyle} ${secondItem}`}
          onClick={this.setPage}
          id={2}
          content='COMPLETE_INFORMATION_ORDER_TOOL_SALARY_INFO_TAB'
        />
        <Translate
          className={`${defaultStyle} ${thirdItem}`}
          onClick={this.setPage}
          id={3}
          content='COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_TAB'
        />
      </div>
    );
  }

  renderBody () {
    switch (this.state.currentPage) {
      case 1:
        return <ContactInformation
          userData={this.state.userData}
          showErrorWithoutBlur={this.state.showErrorWithoutBlur}
          callback={this.callback}
        />;
      case 2:
        return (<div className='modal-information-container'>
          <div className='input-row-container'>
            <Translate
              className='invoicing-description'
              content='COMPLETE_INFORMATION_ORDER_TOOL_SALARY_INFO_DESCRIPTION'
            />
          </div>
          <BankInfoForm
            syncBankInfo
          />
        </div>);
      case 3:
        return <InvoicingInformation
          userData={this.state.userData}
          showErrorWithoutBlur={this.state.showErrorWithoutBlur}
          callback={this.callback}
        />;
      default:
        return null;

    }
  }
  render () {
    if (this.props.invoiceToolCompleteInformationModalIsOpen) {
      return (
        <ModalContainer
          isOpen
          callback={this.props.toggleModal}
          title='COMPLETE_INFORMATION_ORDER_TOOL_TITLE'
          classes='complete-information-modal'
          headerSlot={this.getHeaderSlot()}
          titleMargin
        >
          <div className='complete-information-modal-content'>
            <form noValidate onSubmit={this.submitForm}>
              {this.renderBody()}
            </form>
          </div>
          <div className="new-modal-button-container">
            <button
              className='btn white no-border'
              onClick={this.clickPrevious}>
              <Translate content={this.state.currentPage === 1 ? 'CLOSE' : 'BACK'} />
            </button>
            <SpinnerButton
              text={this.state.currentPage === 3
                ? proxyCounterpart('CREATE_INVOICE')
                : proxyCounterpart('NEXT')}
              loading={this.state.loading}
              classes='btn'
              callback={this.clickNext}
              disabled={!this.pageIsValid()}
            />
          </div>
        </ModalContainer>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = ({ bankInfo }) => ({
  bankInfo,
  isValid: bankInfo.clearingNumber.isValid && bankInfo.accountNumber.isValid
});

const mapDispatchToProps = {
  fetchBanks
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceToolCompleteInformationModal);



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/complete-information-modal/invoice-tool-complete-information-modal.js
 **/